import { render, staticRenderFns } from "./DedicatePage5.vue?vue&type=template&id=cf486c32&scoped=true&"
import script from "./DedicatePage5.vue?vue&type=script&lang=js&"
export * from "./DedicatePage5.vue?vue&type=script&lang=js&"
import style0 from "./DedicatePage5.vue?vue&type=style&index=0&id=cf486c32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf486c32",
  null
  
)

export default component.exports